export const DISPOSITIF_A_FABRIQUER = 'dispositifAFabrique';
export const DISPOSITIF_EN_COURS_FABRICATION = 'dispositifEnCoursFrabrication';
export const DISPOSITIF_FABRICATION_TERMINEE = 'dispositifFrabricationterminee';
export const PAO_BACHE_COMMANDEES = 'paoBacheCommandees';
export const PAO_MAQUETTES_VALIDES = 'paoMaquettesValidees';
export const IMPRESSIONS_TERMINEES = 'impressionsTerminees';
export const DISPOSITIF_EXPEDIE = 'dispositifExpedie';
export const DISPOSTIF_A_FACTURER = 'dispositifAFacturer';
export const DISPOSITIF_A_POSER = 'dispositifAposer';

export const LISTE_COLUMNS_SUIVI_PRODUCTION = [
  DISPOSITIF_A_FABRIQUER,
  DISPOSITIF_EN_COURS_FABRICATION,
  DISPOSITIF_FABRICATION_TERMINEE,
  PAO_BACHE_COMMANDEES,
  PAO_MAQUETTES_VALIDES,
  IMPRESSIONS_TERMINEES,
  DISPOSITIF_A_POSER,
  DISPOSITIF_EXPEDIE,
  DISPOSTIF_A_FACTURER,
];

export const DEMANDE_INTERVENTION_TYPE = 'DemandeIntervention';
export const DEMANDE_IMPRESSION_TYPE = 'DemandeImpression';

export const MODULE_SUIVIPRODUCTION = 'SuiviProduction';
